// The one line the office says after a write landed (UI/UX audit finding 15, 27 Oct 2026).
// Nielsen 1, visibility of status: a grant, a close-out, a correction, a decision that the
// server accepted is said where the form was, as a status (polite, never an alert), with
// what was recorded. It is the counterpart of the `role="alert"` refusal line every form
// already has; a screen never leaves a reader guessing whether the click did anything.
import { Check } from 'lucide-react';

export function Saved({ children }: { children: React.ReactNode }) {
  return (
    <p role="status" className="m-0 flex items-center gap-(--s1) text-(length:--fs-sm) font-semibold text-(--fg)">
      <Check className="size-4 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
